import { render } from "./UltraSlide.vue?vue&type=template&id=a2c5ec24&scoped=true"
import script from "./UltraSlide.vue?vue&type=script&lang=js"
export * from "./UltraSlide.vue?vue&type=script&lang=js"

import "./UltraSlide.vue?vue&type=style&index=0&id=a2c5ec24&scoped=true&lang=css"

import exportComponent from "/mnt/dados/Projects/softline-infinity-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2c5ec24"]])

export default __exports__